import { useCallback, useState } from 'react';

const useTimer = () => {
  const [startTime, setStartTime] = useState(0);

  const resetStart = useCallback(() => {
    setStartTime(Date.now());
  }, [startTime, setStartTime]);

  const getStayTime = useCallback(() => {
    const time = Date.now() - startTime;
    return time;
  }, [startTime, setStartTime]);

  return {
    resetStart,
    getStayTime,
  };
};

export default useTimer;
